export default {
  application_setting: 'Configuración de la aplicación',
  application_information: 'Información de la aplicación',
  public_key: 'Clave pública',
  shared_application_setting: 'Configuración unificada de la aplicación',
  secret_key: 'Clave secreta',
  ip_white_list: 'Lista blanca de IP',
  ip_address: 'Dirección IP',
  user_authentication: 'Autenticación de usuario'
}
